/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
// import { FormattedMessage } from 'react-intl';
// import { Button } from '@micromag/core/components';

import * as AppPropTypes from '../../lib/PropTypes';

const propTypes = {
    organisation: AppPropTypes.organisation.isRequired,
    // services: AppPropTypes.publicationServices.isRequired,
    className: PropTypes.string,
    onComplete: PropTypes.func,
};

const defaultProps = {
    className: null,
    onComplete: null,
};

// eslint-disable-next-line
const PublishForm = ({ organisation, className, onComplete }) => (
    <form className={className}>Publishing settings</form>
);

PublishForm.propTypes = propTypes;
PublishForm.defaultProps = defaultProps;

export default PublishForm;
